"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultParams = void 0;
const sleep_1 = require("../sleep");
exports.defaultParams = {
    timeout: 1200,
    interval: 30,
    delayFn: sleep_1.sleep,
};
//# sourceMappingURL=defaults.js.map